import { render } from "./BaseDashboard.vue?vue&type=template&id=2dfc39d3&scoped=true"
import script from "./BaseDashboard.vue?vue&type=script&lang=js"
export * from "./BaseDashboard.vue?vue&type=script&lang=js"

import "./BaseDashboard.vue?vue&type=style&index=0&id=2dfc39d3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfc39d3"]])

export default __exports__